import { Box, Flex } from '@rebass/grid'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch, RootState } from 'src/store'
import styled, { css } from 'styled-components'
import { Hr } from '../../elements'
import Content from './Content'
import Toolbar from './Toolbar'

const MaterialContainer = styled(Flex).attrs({
  flexDirection: 'column'
}) <{ active: boolean | undefined }>`
  border-radius: 10px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #f7f8f8;
  margin-bottom: 28px;
  max-width: 500px;
  &:last-of-type {
    margin-bottom:0px;
  }
  ${props =>
    props.active &&
    css`
      &:before {
        content: "";
        width: 2px;
        background: #ff730e;
        left: -30px;
        position: absolute;
        height: 100%;
      }
    `}
`

interface IConnectProps {
  lectureId: string
  chapterIdx: number
  insightId: string
  materialIdx: number
}

type IMaterialProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> &
  IConnectProps

const Material: React.SFC<IMaterialProps> = ({
  material,
  isActive,
  isLiked,
  onLike,
  onDiscussOpen,
  onContentStart,
  onContentPause,
  onContentEnd
}) => {
  return (
    <MaterialContainer
      active={isActive}
      ref={ref => {
        if (ref && isActive) {
          ref.scrollIntoView({ behavior: 'smooth' })
        }
      }}
    >
      <Box px={16} pt={16} pb={16}>
        <Content
          isActive={isActive}
          material={material}
          onStarted={onContentStart}
          onPaused={onContentPause}
          onEnded={onContentEnd}
        />
      </Box>
      <Hr />
      <Box>
        <Toolbar
          isLiked={isLiked}
          onLikeClick={onLike}
          onDiscussionClick={onDiscussOpen}
          likes={material.reactions.like.length}
          discussions={material.replyIds.length}
        />
      </Box>
    </MaterialContainer>
  )
}

const mapState = (
  { auth, insights, lectureContent }: RootState,
  { lectureId, chapterIdx, insightId, materialIdx }: IConnectProps
) => {
  const currentUser = firebase.auth().currentUser
  const material = insights[insightId].materials[materialIdx]
  return {
    material,
    isActive:
      lectureContent.currentLectureId === lectureId &&
      lectureContent.currentChapterIdx === chapterIdx &&
      lectureContent.currentInsightId === insightId &&
      lectureContent.currentMaterialIdx === materialIdx,
    isLiked:
      auth.isAuthenticated &&
      currentUser !== null &&
      R.contains(currentUser.uid, material.reactions.like)
  }
}

const mapDispatch = (
  dispatch: Dispatch,
  { lectureId, insightId, materialIdx, chapterIdx }: IConnectProps
) => ({
  onLike: () => {
    dispatch.insights
      .toggleReaction({
        lectureId,
        chapterIdx,
        insightId,
        materialIdx,
        reaction: 'like'
      })
      .catch(err => alert(err.message))
  },
  onDiscussOpen: () => {
    dispatch.discussion.changeCurrentDiscussion({
      chapterIdx,
      insightId,
      materialIdx
    })
  },
  onContentStart: () => {
    dispatch.lectureContent.updateLectureContentState({
      currentChapterIdx: chapterIdx,
      currentInsightId: insightId,
      currentMaterialIdx: materialIdx
    })
    dispatch.lectureContent.startPlaying()
  },
  onContentPause: () => {
    dispatch.lectureContent.stopPlaying()
  },
  onContentEnd: () => {
    dispatch.lectureContent.nextAudioMaterial()
  }
})

export default connect(
  mapState,
  mapDispatch
)(Material)



// WEBPACK FOOTER //
// ./src/components/Material/index.tsx